import { CLASS_NAME } from 'constants/class-names'
import { setStyles } from 'utils/dom'
import { ComponentBase } from 'utils/abstract-classes/component-base'
import { Nullable } from 'constants/types'

const { header: headerClass, vehicleFinder: vehicleFinderClass } = CLASS_NAME

export class HeaderOffsetService extends ComponentBase {
    private targetElement: HTMLElement
    private elements: Record<string, Nullable<HTMLElement>> = {}

    private classMap = {
        [headerClass._]: 'header',
        [headerClass.breaking]: 'breakingNews',
        [headerClass.subscribe]: 'subscribeBtn',
        [vehicleFinderClass.wrapper]: 'vehicleFinder'
    }

    public constructor(el: HTMLElement) {
        super()

        this.targetElement = el

        this.getElements(`.${headerClass.offset}`).forEach(
            (item: HTMLElement) => {
                Object.keys(this.classMap).forEach((className: string) => {
                    if (item.classList.contains(className)) {
                        this.elements[this.classMap[className]] = item
                    }
                })
            }
        )
    }

    public get totalHeaderHeight(): number {
        let totalHeight = 0

        // does main header exist
        if (
            this.elements['header'] &&
            this.elements['header'].getBoundingClientRect().top >= 0
        ) {
            totalHeight = Math.round(
                this.elements['header'].getBoundingClientRect().height
            )
        }

        // does the breaking news banner exist
        if (this.elements['breakingNews']) {
            totalHeight += Math.round(
                this.elements['breakingNews'].getBoundingClientRect().height
            )
        }

        // does the subscribe button exist
        if (this.elements['subscribeBtn']) {
            totalHeight += Math.round(
                this.elements['subscribeBtn'].getBoundingClientRect().height
            )
        }

        // does the vehicle finder exist
        if (this.elements['vehicleFinder']) {
            if (
                this.elements['header'] &&
                this.elements['header'].getBoundingClientRect().top === 0
            ) {
                totalHeight = Math.round(
                    this.elements['header'].getBoundingClientRect().height
                )
            }
            totalHeight += Math.round(
                this.elements['vehicleFinder'].getBoundingClientRect().height
            )
        }

        return totalHeight
    }

    public setStyleTop(): void {
        const totalHeight = this.totalHeaderHeight
        setStyles(this.targetElement, { top: `${totalHeight}px` })
    }
}
